import { render, staticRenderFns } from "./listaPendenze.vue?vue&type=template&id=79aac0d8"
import script from "./listaPendenze.vue?vue&type=script&lang=js"
export * from "./listaPendenze.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports